import { InjectionToken } from "@angular/core";
import { WatermarkParams } from "./watermark-params";

export const ECM_TICKET: string = "ticket-ECM";

// HTTP HEADERS
export const ACCEPT_LANGUAGE_HEADER: string = "Accept-Language";

// APP CONFIG
export const APP_CONFIG_PLUGINS: string = "plugins";
export const APP_CONFIG_TOTP_LOGIN: string = "totp-login";
export const APP_CONFIG_AUDIT_LOG_LOGIN: string = "audit-login";
export const APP_CONFIG_WIDGETS_IMAGE_ICON: string = "widgetsImageIcon";
export const APP_CONFIG_FILE_SIZE_LIMIT: string = "file-size-limit";    // En MB
export const APP_CONFIG_DATE_VALUES: string = "dateValues";
export const APP_CONFIG_MAX_ITEMS_EXPORT: string = "maxItemsExport";
export const APP_CONFIG_MAX_ITEMS_SELECT: string = "maxItemsSelect";
export const APP_CONFIG_MAX_SIZE_DOWNLOAD: string = "maxSizeDownload";

// GROUPS
export const GROUP_PREFIX : string = "GROUP_";

// ALLOWABLE_OPERATION
export const DELETE_ALLOWABLE_OPERATION : string = "delete";
export const UPDATE_ALLOWABLE_OPERATION : string = "update";
export const CREATE_ALLOWABLE_OPERATION : string = "create";
export const UPDATE_PERMISSIONS_ALLOWABLE_OPERATION : string = "updatePermissions";

// FILTER PREQUERY MAX
export const FILTER_PREQUERY_MAX : number = 1000;

// PLUGINS
export const CONTENT_SERVICE_PLUGIN : string = "contentService";
export const EFLOW_PLUGIN : string = "alden-eflow";
export const BUILDER_PLUGIN : string = "alden-builder";
export const SIGNAFORM_PLUGIN : string = "alden-signaform";
export const TAXONOMY_PLUGIN : string = "alden-taxonomy";
export const SIGN_PLUGIN : string = "alden-sign";
export const ENI_PLUGIN : string = "alden-eni";

// INJECTORS
export const RRHH_INTEGRATION_SERVICE: InjectionToken<any> = new InjectionToken<any>('RRHHIntegrationServiceImpl');
export const EFLOW_INTEGRATION_SERVICE: InjectionToken<any> = new InjectionToken<any>('EflowIntegrationServiceImpl');
export const BUILDER_INTEGRATION_SERVICE: InjectionToken<any> = new InjectionToken<any>('BuilderIntegrationServiceImpl');
export const SIGNAFORM_INTEGRATION_SERVICE: InjectionToken<any> = new InjectionToken<any>('SignaformIntegrationServiceImpl');
export const SIGN_INTEGRATION_SERVICE: InjectionToken<any> = new InjectionToken<any>('SignIntegrationServiceImpl');
export const ENI_INTEGRATION_SERVICE: InjectionToken<any> = new InjectionToken<any>('ENIIntegrationServiceImpl');
export const BDOCS_INTEGRATION_SERVICE: InjectionToken<any> = new InjectionToken<any>('BDOCSIntegrationServiceImpl');

//TYPES
export const SMT_RRHH_RECORD_TYPE : string = "smtrrhh:record";
export const SMT_BDOCS_RECORD_TYPE : string = "smtbd:record";

//TYPES
export const CM_FOLDER: string = "cm:folder";
export const CM_CONTENT: string = "cm:content";

//ASPECTS
export const CM_ASPECT_LOCKABLE : string = "cm:lockable";

export const SMT_RRHH_STRUCTURAL_FOLDER_ASPECT : string = "smtrrhh:structuralFolderAsp";
export const SMT_BDOCS_STRUCTURAL_FOLDER_ASPECT : string = "smtbd:structuralFolderAsp";
export const SMT_TAX_GROUPER_DATA_ASPECT : string = "smttax:grouperDataAsp";
export const SMT_TAX_TYPE_DATA_ASPECT : string = "smttax:typeDataAsp";

// PROPERTIES
export const SYS_NODE_UUID_PROP : string = "sys:node-uuid";
export const CM_PROP_TITLE: string = "cm:title";
export const CM_PROP_DESCRIPTION: string = "cm:description";
export const CM_PROP_VERSION_TYPE: string = "cm:versionType";
export const CM_PROP_VERSION_LABEL: string = "cm:versionLabel";
export const CM_PROP_LAST_THUMBNAIL_MODIFICATION: string = "cm:lastThumbnailModification";

//DEFAULT VALUES
export const OPERATORS: Record<string, string> = { '|': 'OR', '*': 'AND'};
export const OPERATORS_LOAD: Record<string, string> = { 'OR': '|', 'AND': '*'};
export const NULL: string = "NULL";

//CONFIG
export const CONFIG_FOLDER_NAME: string = "Config";

//SAVED SEARCHS
export const SEARCH_FOLDER_NAME:string = "searchs";
export const SEARCH_FILE_SUFFIX: string = "search.json";

export const DEFAULT_SEARCH_PROP: string = "defaultSearchID";
export const DEFAULT_CONFIG_PROP: string = "defaultConfigID";

//WATERMARK
export const DEFAULT_WATERMARK_TEXT: string ="COPIA"
export const DEFAULT_WATERMARK_PARAMS: WatermarkParams = {
    watermarkText: DEFAULT_WATERMARK_TEXT,
    red: 190,
    blue: 190,
    green: 190,
    transparency: 100,
    radians: 60
}